import { Navigate } from "react-router";
import { useGetRoleQuery } from "../../../apis/Role.api";
import { PrimaryRole, Role } from "../../../types/models/Role";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const RoleScoped = () => {
    const {
        data,
    } = useGetRoleQuery(PrimaryRole.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/roles/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default RoleScoped;
